// Global branding configuration
// Update these values to change branding across the entire application

export const BRANDING = {
  // Website name displayed in navbar, titles, and sharing
  WEBSITE_NAME: 'ThreadShare',
  
  // Alternative name used in some contexts (e.g., sharing descriptions)
  ALT_NAME: 'ThreadShare',
  
  // Website URL for sharing
  WEBSITE_URL: 'https://threadshare.ai',
  
  // Meta description
  DESCRIPTION: 'Share your AI conversations with the world',
  
  // Extended description for landing pages
  EXTENDED_DESCRIPTION: 'Track and analyze your ChatGPT & Gemini conversations with detailed analytics and share them publicly or privately',
  
  // Sharing description
  SHARING_DESCRIPTION: 'Check out ThreadShare! It helps you organize, track, and share your AI conversations with analytics and insights.',
  
  // Full sharing title
  SHARING_TITLE: 'ThreadShare - Share Your AI Conversations',
  
  // Logo paths for different themes
  // Use absolute paths from public folder (works in both dev and production)
  // In Create React App, files in public/ are served from root, so /assets/... works
  LOGO_LIGHT: '/assets/threadshare_logo.svg',      // For light backgrounds/modes
  LOGO_DARK: '/assets/threadshare_logo_dark.svg',  // For dark backgrounds/modes
  LOGO_DEFAULT: '/assets/threadshare_logo.svg',    // Default logo (light version)
  
  // Social sharing image (1200x630 for optimal social media display)
  SOCIAL_IMAGE: '/assets/threadshare-social-card.png',  // Main social sharing image
  
  // Social sharing card configuration
  SOCIAL_CARD: {
    backgroundColor: '#667eea',
    textColor: '#ffffff',
    accentColor: '#764ba2'
  }
};

// For easier imports, you can also export individual values
export const {
  WEBSITE_NAME,
  ALT_NAME,
  WEBSITE_URL,
  DESCRIPTION,
  EXTENDED_DESCRIPTION,
  SHARING_DESCRIPTION,
  SHARING_TITLE,
  LOGO_LIGHT,
  LOGO_DARK,
  LOGO_DEFAULT,
  SOCIAL_IMAGE,
  SOCIAL_CARD
} = BRANDING;

export default BRANDING;
